module.exports = __webpack_public_path__ + "img/dz.27223588.png";